export const ListQueryKey = 'activityZlConfigs';
export const DetailQueryKey = 'activityZlConfig';
export const Urls = {
  selectUrl: '/ZlQyConfig/list',
  updateUrl: '/ZlQyConfig/update',
  deleteUrl: '/ZlQyConfig/delete',
  createUrl: '/ZlQyConfig/create',
  detailUrl: '/ZlQyConfig/detail'
}; // /api/ZlQyConfig/list